<script setup>
// @ts-check
import { ref } from 'vue'
import { RouterView, useRouter } from 'vue-router'
import { setup } from './useSignupForm.js'
/**
 * @import { Ref, PropType } from 'vue'
 * @import { ComponentProps } from '../../propTypes.js'
 */
defineProps({
  inputErrors: {
    /** @type {PropType<ComponentProps["inputErrors"]>} */
    type: Object,
    required: true,
  },
})

/** @type {Ref<HTMLFormElement|undefined>} */
const refForm = ref()

const { relayParams, setParam, submit } = setup(refForm)

const router = useRouter()
router.push({ name: 'basic', params: {} })

const submitUrl = /** @type {HTMLInputElement|undefined} */ (document.getElementById('url_action'))?.value
const csrfToken = /** @type {HTMLInputElement|undefined} */ (document.getElementById('csrf_token'))?.value
const pk = new URLSearchParams(window.location.search).get('PK')
const pp = /** @type {HTMLInputElement|undefined} */ (document.getElementById('pp'))?.value
const channel = /** @type {HTMLInputElement|undefined} */ (document.getElementById('channel'))?.value
const comparelpcd = /** @type {HTMLInputElement|undefined} */ (document.getElementById('comparelpcd'))?.value
</script>

<template>
  <form
    ref="refForm"
    :action="submitUrl"
    method="post"
    @submit.prevent
  >
    <input
      type="hidden"
      name="_token"
      :value="csrfToken"
    />
    <input
      type="hidden"
      name="_pp_"
      :value="pp"
    />
    <input
      type="hidden"
      name="channel"
      :value="channel"
    />
    <input
      type="hidden"
      name="comparelpcd"
      :value="comparelpcd"
    />
    <input
      type="hidden"
      v-for="(val, key) in relayParams"
      :key="key"
      :name="key"
      :value="val"
    />
    <input
      type="hidden"
      name="PK"
      :value="pk"
    />
    <RouterView
      :inputErrors="inputErrors"
      :formParams="relayParams"
      @setParam="setParam"
      @submit="submit"
    />
  </form>
</template>
